import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PokerApi, PokerGameFormatType, PokerGameModel } from 'mvppoker-portal-common/api'
import { useNavigate } from '../navigation'
import { usePublicWebsocketConnection } from '../../logic/websockets/usePublicWebsocketConnection'
import { store } from '../../state/AppStore'
import { updatePublicRooms, makePublicActiveGame } from '../../state/reducers/PublicUserReducer'
import { websocketConnection } from '../../logic/websockets/Websockets'
import RoomsTableItem from '../Lobby/RoomsTable/Vertical/RoomsTableItem'
import { env, whenEnv } from '../../config/env'
import { MVPButton } from '../../Views/Buttons/MVPButton'
import LoadingModal from '../../Views/modals/LoadingModal/LoadingModal'
import { handleError, useApi } from '../../utils/useApi'
import { usePublicRooms, usePublicUserId } from '../../state/hooks/PublicUserHooks'
import '../../index.scss'
import './PublicGamesPage.scss'

const REFRESH_RATE = 6_000

export default () =>
{
	usePublicWebsocketConnection()

	const dispatch = useDispatch()
	const userId = usePublicUserId()
	const rooms = usePublicRooms()
	const gotoGame = useNavigate('publicGame')
	const gotoRegister = useNavigate('registrationCredentials')
	const pokerApi = useApi(PokerApi)

	const sortedRooms = useMemo(() => {
		return rooms
		.filter((it) => !it.status.hidden)
		.sort((a, b) => b.players.length - a.players.length)
	}, [rooms])

	useEffect(() => {
		const refreshTask = () => {
			websocketConnection.requestRoomsUpdate((rooms) => {
				store.dispatch(updatePublicRooms(rooms.filter(r => r.config.format === PokerGameFormatType.Cash)))
			})
		}

		refreshTask()
		const id = setInterval(refreshTask, REFRESH_RATE)

		return () => {
			websocketConnection.disconnect()
			clearInterval(id)
		}
	}, [])

	const handleClickRoom = (game: PokerGameModel) =>
	{
		const alertCallback = LoadingModal.Show({ text: 'Entering\nPlease wait...' })
	
		pokerApi
			.pokerRoomsPublicEnter(game.id, userId)
			.then(() => {
				alertCallback()
				dispatch(makePublicActiveGame({ ...game, userId }))
				gotoGame({ replace: true })
			})
			.catch(handleError)
	}

	const onClickRegister = () => {
		gotoRegister({ replace: true })
	}

	const items = sortedRooms.map((it) => (
		<RoomsTableItem
			key={it.id}
			format={PokerGameFormatType.Cash}
			room={it}
			onClick={() => {
				handleClickRoom(it)
			}}
			isSelected={false}
		/>
	))

	return (
		<div id='publicgames-page'>
			<div id='center-col'>
				<h1>WATCH OUR LIVE DEALT POKER</h1>
				<div id='vertical-center-box'>
					<div id='room-table' className='room-table--vertical -no-scrollbar'>
						{items}
					</div>
				</div>
			</div>
			
			{whenEnv('prod', true) &&
			<MVPButton id='register-button' onClick={onClickRegister}>
				Want a piece of the action? JOIN NOW!
			</MVPButton>
			}
			<h1 id="topinfo">PLAYMONEY GAMES</h1>
		</div>
	)
}
